// dark
import shinhan_dark from "../assets/stakeholder_logo/dark/shinhan.svg";
import bass_dark from "../assets/stakeholder_logo/dark/bass.svg";
import aton_dark from "../assets/stakeholder_logo/dark/aton.svg";
import kdb_dark from "../assets/stakeholder_logo/dark/kdb.svg";
import kb_investment_dark from "../assets/stakeholder_logo/dark/kb_investment.svg";
import theseed_dark from "../assets/stakeholder_logo/dark/theseed.svg";
import tyel_dark from "../assets/stakeholder_logo/dark/tyel.svg";
import simone_dark from "../assets/stakeholder_logo/dark/simone.svg";

// light
import shinhan_light from "../assets/stakeholder_logo/light/shinhan.svg";
import bass_light from "../assets/stakeholder_logo/light/bass.svg";
import aton_light from "../assets/stakeholder_logo/light/aton.svg";
import kdb_light from "../assets/stakeholder_logo/light/kdb.svg";
import kb_investment_light from "../assets/stakeholder_logo/light/kb_investment.svg";
import theseed_light from "../assets/stakeholder_logo/light/theseed.svg";
import tyel_light from "../assets/stakeholder_logo/light/tyel.svg";
import simone_light from "../assets/stakeholder_logo/light/simone.svg";

export const stakeholderList = [
	{ id: "shinhan", name: "신한", logo: { dark: shinhan_dark, light: shinhan_light } },
	{ id: "bass", name: "BASS", logo: { dark: bass_dark, light: bass_light } },
	{ id: "aton", name: "아톤", logo: { dark: aton_dark, light: aton_light } },
	{ id: "kdb", name: "KDB", logo: { dark: kdb_dark, light: kdb_light } },
	{ id: "kb_investment", name: "KB인베스트먼트", logo: { dark: kb_investment_dark, light: kb_investment_light } },
	{ id: "theseed", name: "더시드그룹", logo: { dark: theseed_dark, light: theseed_light } },
	{ id: "tyel", name: "TYEL", logo: { dark: tyel_dark, light: tyel_light } },
	{ id: "simone", name: "시몬", logo: { dark: simone_dark, light: simone_light } },
];
